import React, { useContext, useState } from "react";
import "./FiredashboardCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThemeContext } from "../../../..";

export default function FireDashboardcard({
  data,
  config,
  clickedKey,
  setClickedKey,
  triggeredFunction,
  onIncidentSelect,
  startDateStr,
  endDateStr,
  cardData = [],
}) {
  const colors = ["#333c67"];
  const [selectedCard, setSelectedCard] = useState(null);
  const { theme } = useContext(ThemeContext);

  const currentCardData = cardData && cardData.length > 0 ? cardData[0] : {};


  const formatCardData = (value) => {
    if (!value) return 0; // Ensure default value if undefined/null
    if (typeof value === "string") {
      const splitValue = value.split("(");
      return (
        <>
          {splitValue[0]} <br /> {splitValue[1]}
        </>
      );
    }
    return value;
  };

  console.log(cardData, "dashboardcard");

  const handleCardClick = (conf) => {
    setSelectedCard(conf.key);
    if (onIncidentSelect) {
      onIncidentSelect(conf.key);
    }
  };

  // Recursive function to render sub-data with proper key mappings
  const renderSubData = (subData) => {
    return (
      <div className="sub-data-container">
        {subData.map((sub, idx) => (
          <div
            key={idx}
            className={`${
              theme === "light" ? "sub-data-item-light" : "sub-data-item"
            } ${
              selectedCard === sub.key ? "highlighted-card" : ""
            }`}
            onClick={(e) => {
              e.stopPropagation();
              handleCardClick(sub);
            }}
          >
            <FontAwesomeIcon icon={sub.icon} size="2x" style={{ color: theme === "light" ? "black" : undefined }} />
            <div className={theme === "light" ? "sub-label-light" : "sub-label"}>{sub.label}</div>
            <div className={theme === "light" ? "sub-label-light" : "sub-label"}>
              {formatCardData(currentCardData?.[sub.key])}
            </div>
            {sub.subData && renderSubData(sub.subData)}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="dashboard_card_fire">
      <div>{config.title}</div>
      <div className="d-grid gap-2 mt-1">
        {config?.data.map((conf, index) => (
          <div
            key={index}
            className={`ds-single_card_cw_fire cursor-pointer grid-container-cw-fire  ${
              selectedCard === conf.key ? (theme === "light" ? "highlighted-card-light" : "highlighted-card") 
                  : ""
            }`}
            onClick={() => handleCardClick(conf)}
            style={{ backgroundColor: theme === "light" 
              ? "#f0f0f0" 
              : colors[index % colors.length] }}
          >
            <div className={theme === "light" ? "card-icon-fire-light" : "card-icon-fire"}>
              {conf.icon && <FontAwesomeIcon icon={conf.icon} size="3x" />}
            </div>
            <div
              className={`${
                theme === "light" ? "card-label-fire-light" : "card-label-fire"
              } ${
                conf.subData
                  ? conf.subData.some((sub) => sub.subData)
                    ? theme === "light"
                    ? "nested-sub-data-light"
                    : "nested-sub-data"
                    : theme === "light"
                    ? "has-sub-data-light"
                    : "has-sub-data"
                  : ""
              }`}
            >
              {conf.label}
            </div>

            <div
              className={`${
                theme === "light" ? "card-data-fire-light" : "card-data-fire"
              } ${
                conf.subData
                  ? conf.subData.some((sub) => sub.subData)
                    ? theme === "light"
                    ? "nested-card-data-light"
                    : "nested-card-data"
                    : theme === "light"
        ? "has-card-data-light"
        : "has-card-data"
                  : ""
              }`}
            >
              {formatCardData(currentCardData?.[conf.key])}
            </div>
            {conf.subData && renderSubData(conf.subData)}
          </div>
        ))}
      </div>
    </div>
  );
}
